<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-instituciones"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { TIPOS_INSTITUCIONES } from '../utils/constantes';
import { cellRendererNumeroRegistro, cellRendererSiONo } from '../utils/funciones';

export default {
  name: 'ListadoInstituciones',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          minWidth: 300,
        },
        {
          headerName: 'ABREVIATURA',
          field: 'abreviatura',
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'TIPO',
          cellRenderer: (params) => {
            return params.data.tipo == TIPOS_INSTITUCIONES.UNIVERSIDAD ? 'Universidad' : 'Instituto';
          },
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'CONVENIO',
          cellRenderer: cellRendererSiONo('convenio', 'Si', 'No'),
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: cellRendererSiONo('estado', 'Activo', 'Inactivo'),
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-instituciones {
  height: calc(var(--vh, 1vh) * 100 - 14rem);
}
</style>
  